import * as RadioGroup from "@radix-ui/react-radio-group";
import { forwardRef } from "react";
import { cn } from "~/utils/shadcn";

export const Root = forwardRef<
  HTMLDivElement,
  React.ComponentProps<typeof RadioGroup.Root>
>((props, ref) => (
  <RadioGroup.Root
    {...props}
    ref={ref}
    className={cn(props.className, "flex gap-4 overflow-auto scrollbar-hide")}
  >
    {props.children}
  </RadioGroup.Root>
));
Root.displayName = RadioGroup.Root.displayName;

export const Item = forwardRef<
  HTMLButtonElement,
  React.ComponentProps<typeof RadioGroup.Item> & {
    color?: string;
    image?: string | null;
  }
>((props, ref) => {
  if (props.image) {
    return (
      <RadioGroup.Item
        {...props}
        ref={ref}
        className={cn(
          props.className,
          "flex-shrink-0 rounded-lg overflow-clip transition-all flex items-center justify-center",
          "data-[state=checked]:bg-secondary data-[state=checked]:text-secondary-foreground data-[state=checked]:hover:bg-secondary/80 [&>img]:data-[state=checked]:opacity-100 [&>img]:data-[state=checked]:grayscale-0",
          "data-[state=unchecked]:border data-[state=unchecked]:border-input data-[state=unchecked]:bg-background data-[state=unchecked]:hover:bg-accent data-[state=unchecked]:hover:text-accent-foreground",
          "data-[disabled]:bg-muted data-[disabled]:text-muted-foreground data-[disabled]:border data-[disabled]:border-muted data-[disabled]:hover:bg-muted data-[disabled]:hover:text-muted-foreground data-[disabled]:hover:border-muted data-[disabled]:cursor-not-allowed data-[disabled]:pointer-events-none data-[disabled]:opacity-50"
        )}
      >
        <img
          className="h-12 w-12 object-cover grayscale opacity-60"
          src={props.image}
          alt=""
          style={{
            clipPath: "polygon(0 0, 100% 0, 50% 100%, 0% 100%)",
            transition: "opacity 0.3s ease",
          }}
        />
        <div className="py-3 px-6 -ml-6">{props.children}</div>
      </RadioGroup.Item>
    );
  }

  return (
    <RadioGroup.Item
      {...props}
      ref={ref}
      className={cn(
        props.className,
        "flex flex-shrink-0 items-center justify-center py-3 px-6 rounded-lg transition-all",
        "data-[state=checked]:bg-secondary data-[state=checked]:text-secondary-foreground data-[state=checked]:hover:bg-secondary/80",
        "data-[state=unchecked]:border data-[state=unchecked]:border-input data-[state=unchecked]:bg-background data-[state=unchecked]:hover:bg-accent data-[state=unchecked]:hover:text-accent-foreground",
        "data-[disabled]:bg-muted data-[disabled]:text-muted-foreground data-[disabled]:border data-[disabled]:border-muted data-[disabled]:hover:bg-muted data-[disabled]:hover:text-muted-foreground data-[disabled]:hover:border-muted data-[disabled]:cursor-not-allowed data-[disabled]:pointer-events-none data-[disabled]:opacity-50"
      )}
    >
      {props.children}
    </RadioGroup.Item>
  );
});
Item.displayName = RadioGroup.Item.displayName;

export const Indicator = forwardRef<
  HTMLSpanElement,
  React.ComponentProps<typeof RadioGroup.Indicator>
>((props, ref) => (
  <RadioGroup.Indicator ref={ref} {...props}>
    {props.children}
  </RadioGroup.Indicator>
));
Indicator.displayName = RadioGroup.Indicator.displayName;
